import Helper from "./Helper";

class InteractiveSvg {
  constructor(config = {}) {
    const { idName, className } = config;

    this.idName = idName;
    this.className = className;
    this.currentVisible = null; // Track the current visible element

    const svgs = Array.prototype.slice.call(document.querySelectorAll('.lc-interactive-svg'));
    //console.log(svgs);

    svgs.forEach(svg => {
      const triggers = Array.prototype.slice.call(
        svg.querySelectorAll(`g[id*="${this.idName}"]`)
      );

      console.log(triggers);

      triggers.forEach(trigger => {
        trigger.addEventListener("mouseover", () => {
          const triggerNum = trigger.id.replace(this.idName, "");
          const hover = svg.querySelector(`.${className}${triggerNum}`);

          // If there's a currently visible element, remove the class from it
          if (this.currentVisible && this.currentVisible !== hover) {
            Helper.removeClass(this.currentVisible, "is-visible");
          }

          // Show on hover
          Helper.addClass(hover, "is-visible");

          // Update the currently visible element
          this.currentVisible = hover;
        });

        /* trigger.addEventListener("mouseout", () => {
          // Remove "is-visible" from the hovered element when mouse leaves
          if (this.currentVisible) {
            Helper.removeClass(this.currentVisible, "is-visible");
            this.currentVisible = null; // Reset visibility tracking
          }
        }); */
      });
    });
  }
}

export default InteractiveSvg;


